import React from 'react';
import { useTranslation } from 'react-i18next';
import {menuDb} from '../../constants/data';
import certificateImg from '../../assets/images/logo/certificate.avif';
import {Link} from "react-router-dom";
import settings from "../../constants/settings";
import {emailEnvelopIcon, locationIcon, phoneIcon} from "../../constants/svgIcons";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className={'bg-white pt-20'}>
      <div className="md:w-theme-container w-mobile-container mx-auto h-auto upper-footer mb-3">
        <div className="grid grid-cols-1 md:grid-cols-[45%_auto]">
          <div className="h-auto">
            <div className="w-60 py-8">
              <img className="w-full" src={certificateImg} alt=""/>
            </div>
            <div className="md:text-lg md:w-9/12 text-base opacity-80">
              {t('common.aboutUsDescription')}
            </div>
          </div>
          <div className="">
            <div className="grid grid-cols-2 md:grid-cols-2">
              <div className="mt-10">
                {/*<SlideUp>*/}
                <div className="md:text-2xl text-xl">{t('common.products')}</div>
                {/*</SlideUp>*/}
                <ul className="mt-8">
                  {menuDb.mainMenu[1].submenu.map((item, index) => (
                    <div
                      key={index}
                    >
                      {/*<SlideUp>*/}
                      <li
                        key={item.id}
                        className="md:text-base text-sm hover:translate-x-4 hover:underline hover:text-theme-color transition-transform duration-200 mb-3 opacity-70"
                      >
                        <Link to={`${settings.domain}${item.routePath}`}>{t(`common.${item.translateKey}`)}</Link>
                      </li>
                      {/*</SlideUp>*/}
                    </div>
                  ))}
                </ul>
              </div>
              <div className="mt-10">
                {/*<SlideUp>*/}
                <div className="md:text-2xl text-xl">{t('common.services')}</div>
                {/*</SlideUp>*/}
                <ul className="mt-8">
                  {menuDb.mainMenu[2].submenu.map((item, index) => (
                    <div
                      key={index}
                    >
                      {/*<SlideUp>*/}
                      <li
                        key={index}
                        className="md:text-base text-sm hover:translate-x-4 hover:underline hover:text-theme-color transition-transform duration-200 mb-3 opacity-70"
                      >
                        <Link to={`${settings.domain}${item.routePath}`}>
                          {/*{t(`services.${index}.title`)}*/}
                          {t(`common.${item.translateKey}`)}
                        </Link>
                      </li>
                      {/*</SlideUp>*/}
                    </div>
                  ))}
                </ul>
              </div>
              {/* Add second column or content here if needed */}
            </div>
          </div>
        </div>
        <div className="mid-footer my-1 mt-12 md:mt-0">
          {/*<SlideUp>*/}
          <div className="grid md:grid-cols-[70%_auto] lg:grid-cols-[55%_auto] bg-red-3000">
            <div className="grid grid-cols-1 md:grid-cols-[300px_auto] gap-3 bg-yellow-30000">
              <div className="flex justify-between items-start">
                <div className="flex flex-col items-start gap-1">
                  <div className="flex gap-2">
                    {phoneIcon()}
                    <div className="md:text-xl text-xl">{t('common.phone')}</div>
                  </div>
                  <div>
                    <ul className="my-2">
                      <li
                        className="text-sm md:text-base hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start opacity-70"
                      >
                        <a href="tel:+97142829613">+971 4 2829 613</a>
                      </li>
                      <li
                        className="text-sm md:text-base hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start opacity-70"
                      >
                        <a href="tel:+971505707868">+971 50 570 7868</a>
                      </li>
                      <li
                        className="text-sm md:text-base hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start opacity-70"
                      >
                        <a href="tel:+97142821944">+971 4 2821 944</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="flex flex-col items-start gap-1">
                  <div className="flex gap-2">
                    {emailEnvelopIcon}
                    <div className="md:text-xl text-xl">{t('common.email')}</div>
                  </div>
                  <div>
                    <ul className="my-2">
                      <li
                        className="text-base md:text-lg hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start opacity-70"
                      >
                        <a href="mailto:info@mesoft.ae">info@mesoft.ae</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-span-2 md:col-span-1 mb-5 mt-3 md:mt-0">
                <div className="flex flex-col items-start gap-1">
                  <div className="flex gap-2">
                    {locationIcon}
                    <div className="md:text-xl text-xl">{t('common.location')}</div>
                  </div>
                  <div>
                    <ul className="my-2">
                      <li
                        className="md:text-base text-sm hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start opacity-70"
                      >
                        <a target="_blank"
                           href="https://maps.app.goo.gl/WbUrhCfXrEvJPaYS7">{t('common.addressDescription')}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="social-div flex md:justify-end items-center bg-violet-9500">
              {/* Add social icons if needed */}
              <ul className="flex gap-5">
                <li>
                  <a href="https://mesoft.ae" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/facebook.png')}
                      alt="Facebook"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://mesoft.ae" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/linkedin.png')}
                      alt="LinkedIn"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://mesoft.ae" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/youtube.png')}
                      alt="YouTube"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/mesoftuae/" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/insta-logo.png')}
                      alt="Instagram"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/*</SlideUp>*/}
        </div>
      </div>

      <div className="lower-footer bg-slate-100 h-20 flex justify-between items-center">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="flex justify-between items-center">
            <div className="text-sm md:text-lg text-slate-500">
              {t('common.copyRight')} 2025 @ Mesoft. {t('common.allRightReserved')}.
            </div>
            <Link
              to={'/privacy-policy'}
              className="text-sm md:text-lg hover:text-theme-color hover:underline text-slate-500">
              {t('common.privacyPolicy')}
            </Link>
          </div>
        </div>
      </div>
      <div
        className="fixed z-50 bg-green-400 shadow-lg w-12 h-12 md:w-14 md:h-14 md:right-20 md:bottom-20 right-5 bottom-5 rounded-full flex items-center justify-center">
        <a href="https://wa.me/971505707868?text=I'm%20interested" target="_blank" className="pulse w-12 h-12 md:w-14 md:h-14">
          <img src={require('../../assets/images/whatsapp.avif')} alt=""/>
        </a>
      </div>
    </div>
  );
};

export default Footer;
